<template>
    <div class="card card-sidepanel h-100 bg-ng">
        <div class="card-header shadow-lg">
            <div class="btn-group float-left">
                <button class="btn btn-panel" :class="{'btn-panel-active': tabSettings.activeTab === 'video', 'disabled': !shouldVideoBeClickable}"
                        :disabled="!shouldVideoBeClickable"
                        @click="setActiveTab('video')"
                        v-if="$store.getters.instanceInPostProcessingMode"
                >
                    <i class="fa fa-play"></i>
                    <span class="d-none d-xl-inline d-xs-inline">&nbsp;Video</span>
                </button>
                <button class="btn btn-panel" :class="{'btn-panel-active': tabSettings.activeTab === 'livestream', 'disabled': !shouldLiveStreamBeClickable}"
                        :disabled="!shouldLiveStreamBeClickable"
                        @click="setActiveTab('livestream')"
                        v-if="$store.getters.instanceInLiveMode"
                >
                    <i class="fa fa-play"></i>
                    <span class="d-none d-xl-inline d-xs-inline">&nbsp;Livestream</span>

                </button>
              <button class="btn btn-panel" :class="{'btn-panel-active': tabSettings.activeTab === 'devicecontrol'}" @click="setActiveTab('devicecontrol')" v-if="$store.getters.instanceInLiveMode">
                <i class="fa fa-laptop-code"></i>
                  <span class="d-none d-xl-inline d-xs-inline">&nbsp;Device Control</span>
              </button>
                <button class="btn btn-panel" :class="{'btn-panel-active': tabSettings.activeTab === 'memberlist'}" @click="setActiveTab('memberlist')" v-if="!$store.getters.instanceInReadOnly">
                    <i class="fa fa-user-friends"></i>
                    <span class="d-none d-xl-inline d-xs-inline">&nbsp;Members</span>
                </button>
                <button class="btn btn-panel" :class="{'btn-panel-active': tabSettings.activeTab === 'events'}" @click="setActiveTab('events')" v-if="!$store.getters.instanceInReadOnly">
                    <i class="fa fa-calendar-alt"></i>
                    <span class="d-none d-xl-inline d-xs-inline">&nbsp;Events</span>
                </button>
            </div>
            <!-- Edit Mode Button in Member & Event Tab -->
            <button class="float-right btn btn-panel"
                    :class="{'btn-panel-active': (tabSettings.activeTab === 'memberlist' || tabSettings.activeTab === 'events') && $store.getters.instanceGroupEditEnabled}"
                    @click="$store.dispatch('toggleGroupEditMode')"
                    v-if="(tabSettings.activeTab === 'memberlist' || tabSettings.activeTab === 'events') && !$store.getters.instanceInReadOnly">
                <i class="fa fa-edit"></i>
                <!--<span class="d-none d-xl-inline">&nbsp;{{ $t('UI_INSTANCE_MEMBER_GROUP_TOGGLE_EDIT_MODE') }}</span>-->
            </button>
        </div>
        <div class="card-body bg-light p-0 overflow-auto position-relative" style="max-height: calc(100% - 39px) !important;" v-if="tabSettings.activeTab === 'video'" :key="1">
            <VideoContainer :instance="instance"></VideoContainer>
        </div>
        <div class="card-body bg-light p-0 overflow-auto h-inherit" v-else-if="tabSettings.activeTab === 'livestream'" :key="2">
            <div class="row no-gutters">
                <div class="col-md-12 h-inherit">
                    <LivestreamPanel/>
                </div>
            </div>
        </div>
        <div class="card-body bg-light p-0 overflow-auto h-inherit" v-else-if="tabSettings.activeTab === 'memberlist'" :key="3">
            <div class="col-md-12 position-relative">
                <MemberList :members="instance.members"></MemberList>
            </div>
        </div>
      <div class="card-body bg-light p-0 overflow-auto h-inherit" v-else-if="tabSettings.activeTab === 'events'" :key="3">
        <EventPanel></EventPanel>
      </div>
      <div class="card-body bg-light p-0 overflow-auto h-inherit" v-else-if="tabSettings.activeTab === 'devicecontrol'" :key="3">
        <DeviceControlPanel/>
      </div>
    </div>

</template>

<script>
import VideoContainer from './panels/VideoContainer';
import MemberList from './panels/MemberList/MemberList';
import LivestreamPanel from './panels/LivestreamPanel';
import EventPanel from './panels/Events/EventPanel';
import DeviceControlPanel from './panels/DeviceControl/DeviceControlPanel';

export default {
  name: 'SidePanelCard',
  components: {
    DeviceControlPanel, EventPanel, LivestreamPanel, MemberList, VideoContainer,
  },
  props: ['position'],
  mounted() {},
  methods: {
    setActiveTab(tab) {
      if (tab === 'video' && !this.shouldVideoBeClickable) return false;

      return this.$store.commit('setActiveSidePanelTab', { position: this.position, tab });
    },
  },
  watch: {
    shouldVideoBeClickable(val) {
      if (val === false) {
        if (this.tabSettings.activeTab === 'video') this.setActiveTab('memberlist');
      }
    },
    shouldLiveStreamBeClickable(val) {
      if (val === false) {
        if (this.tabSettings.activeTab === 'livestream') this.setActiveTab('memberlist');
      }
    },
  },
  computed: {
    shouldVideoBeClickable() {
      if (this.$store.getters.instanceInLiveMode) return false;

      if (this.position === 'top') {
        const bottom = this.$store.getters.getSidePanelBottomTabSettings;
        return bottom.activeTab !== 'video';
      }
      const top = this.$store.getters.getSidePanelTopTabSettings;
      return top.activeTab !== 'video';
    },
    shouldLiveStreamBeClickable() {
      if (this.$store.getters.instanceInPostProcessingMode) return false;

      if (this.position === 'top') {
        const bottom = this.$store.getters.getSidePanelBottomTabSettings;
        return bottom.activeTab !== 'livestream';
      }
      const top = this.$store.getters.getSidePanelTopTabSettings;
      return top.activeTab !== 'livestream';
    },
    tabSettings() {
      if (this.position === 'top') return this.$store.getters.getSidePanelTopTabSettings;
      return this.$store.getters.getSidePanelBottomTabSettings;
    },
    instance() {
      return this.$store.getters.activeInstanceData;
    },
  },
};
</script>

<style scoped>

</style>
